import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-plus.svg'
import _imports_1 from '@/assets/icons/close.svg'


const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "inclusion-input-wr w-50" }
const _hoisted_5 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_6 = {
  key: 0,
  class: "error-hint xlsx-error-hint"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "inclusion-input-wr" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_12 = { class: "input-row description-input-row" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "image-wr inclusion" }
const _hoisted_18 = {
  key: 0,
  class: "image-remove-wr"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "upload-image-wr mb-3"
}
const _hoisted_22 = { class: "upload-image-button-wr bigger" }
const _hoisted_23 = ["for"]
const _hoisted_24 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_25 = ["id", "onChange"]
const _hoisted_26 = { class: "controls" }
const _hoisted_27 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ModalWithHeader"], {
      isOpen: $props.isOpen,
      maxWidth: true,
      onClose: $setup.close
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString($props.mode === "create" ? "Add" : "Update") + " Inclusion", 1)
      ]),
      description: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "Package Name", -1)),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { 'input--error': $setup.v$?.type?.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.type) = $event)),
                  placeholder: "Type"
                }, null, 2), [
                  [_vModelText, $setup.form.type]
                ]),
                ($setup.v$?.type?.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.v$?.type?.$errors[0]?.$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["xlsx-upload-section mt-4 mb-4", { 'input--error': $setup.xlsxError }])
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "upload-xlsx-button-wr" }, [
                _createElementVNode("label", {
                  class: "upload-xlsx-button",
                  for: 'xlsx-upload'
                }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "uploadXlsx"
                  }),
                  _createElementVNode("p", null, "Upload XLSX File")
                ])
              ], -1)),
              _createElementVNode("input", {
                class: "input-file-upload-xlsx hidden",
                id: "xlsx-upload",
                type: "file",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.target.value = '')),
                onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.onUploadXlsx($event))),
                accept: ".xlsx, .xls"
              }, null, 32)
            ], 2),
            ($setup.xlsxError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.xlsxError), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.inclusions, (inclusion, incIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "inclusion-group",
                key: incIndex
              }, [
                (incIndex > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "delete-package-button",
                      type: "button",
                      onClick: ($event: any) => ($setup.removeInclusion(incIndex))
                    }, "✖", 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "Category Name", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["input", { 'input--error': $setup.customErrors[incIndex] }]),
                      "onUpdate:modelValue": ($event: any) => ((inclusion.name) = $event),
                      placeholder: "Category Name"
                    }, null, 10, _hoisted_10), [
                      [_vModelText, inclusion.name]
                    ]),
                    ($setup.customErrors[incIndex])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Category Name is required"))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "Item Name", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inclusion.description, (desc, descIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "description-group",
                      key: descIndex
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          class: "input description-input",
                          "onUpdate:modelValue": ($event: any) => ((inclusion.description[descIndex]) = $event),
                          placeholder: "Item Name"
                        }, null, 8, _hoisted_13), [
                          [_vModelText, inclusion.description[descIndex]]
                        ]),
                        (descIndex > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "delete-description-button",
                              type: "button",
                              onClick: ($event: any) => ($setup.removeDescription(incIndex, descIndex))
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "close"
                              }, null, -1)
                            ]))], 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  class: "new-description button p-2 primary mr-0",
                  type: "button",
                  onClick: ($event: any) => ($setup.addDescription(incIndex))
                }, [
                  _createElementVNode("img", {
                    class: "trash-edit-img",
                    src: require(`@/assets/icons/icon-plus-white.svg`)
                  }, null, 8, _hoisted_16)
                ], 8, _hoisted_15),
                _createElementVNode("div", _hoisted_17, [
                  (inclusion.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: "remove-image",
                          onClick: ($event: any) => (inclusion.url = '')
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "close"
                          }, null, -1)
                        ]))], 8, _hoisted_19),
                        _createElementVNode("img", {
                          class: "inclusion-upload",
                          src: inclusion.url
                        }, null, 8, _hoisted_20)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                            for: 'file-upload-' + incIndex
                          }, [
                            _cache[12] || (_cache[12] = _createElementVNode("img", {
                              src: _imports_0,
                              alt: "uploadImage"
                            }, null, -1)),
                            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Upload image", -1)),
                            ($setup.isUploadingImage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_23)
                        ])
                      ])),
                  _createElementVNode("input", {
                    class: "input-file-upload-image hidden",
                    id: 'file-upload-' + incIndex,
                    type: "file",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($event.target.value = '')),
                    onChange: (e) => $setup.onUploadImage(e, incIndex),
                    accept: "image/*"
                  }, null, 40, _hoisted_25)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", { class: "add-package" }, [
              _createElementVNode("button", {
                class: "button p-2 primary mr-0",
                type: "button",
                onClick: $setup.addInclusion
              }, "Add Package")
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "button p-2 cancel",
                type: "button",
                onClick: $setup.close
              }, "Cancel"),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button p-2 primary mr-0",
                    onClick: $setup.confirm
                  }, "Confirm"))
                : (_openBlock(), _createElementBlock("div", _hoisted_27))
            ])
          ], 32)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode($setup["ImageCropperModal"], {
      isOpen: $setup.isCropperModalOpen,
      image: $setup.imageToUpload.data,
      onOnCropImage: $setup.onCropImage,
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.isCropperModalOpen = false))
    }, null, 8, ["isOpen", "image"])
  ], 64))
}